import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type IntentProjectPoliciesDetachConfirmationModalProps = {
  policyName: string;
  onConfirm: () => void;
};

const IntentProjectPoliciesDetachConfirmationModal = create(
  ({ policyName, onConfirm }: IntentProjectPoliciesDetachConfirmationModalProps) => {
    const modal = useModal();

    return (
      <ConfirmationModal
        title="Detach policy"
        confirmationButtonLabel="Detach"
        confirmationButtonVariant="dangerPrimary"
        onConfirm={() => {
          onConfirm();
          modal.hide();
        }}
        onClose={() => modal.hide()}
      >
        <ConfirmationModalMessage>
          Are you sure you want to detach the <strong>{policyName}</strong> policy?
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showIntentProjectPoliciesDetachConfirmationModal = (
  props: IntentProjectPoliciesDetachConfirmationModalProps
) => {
  show(IntentProjectPoliciesDetachConfirmationModal, props);
};
